export const formatMoney = (value: number | null): string => {
  if (!value) return 'R$ 0,00';

  const formattedValue: string = (value).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return formattedValue;
};

export const formatDate = (date: any): string => {
  if (date && date != undefined && date != '') {
    const d: Date = new Date(date);

    let month: string = `${d.getMonth() + 1}`;
    let day: string = `${d.getDate()}`;
    if (month.length < 2) { month = `0${month}`; }
    if (day.length < 2) { day = `0${day}`; }

    const year: number = d.getFullYear();
    const hour: number = d.getHours();
    const minutes: number = d.getMinutes();
    const seconds: number = d.getSeconds();

    if (hour || minutes) {
      const dateString = [year, month, day].join('-');
      return `${dateString} ${hour}:${minutes}:${seconds}`;
      // output format: yyyy-mm-dd
    } else return [year, month, day].join('-');
  }
  return '';
};

export const formatAcquirer = (acquirer: any): string => {
  let acquirerStr: string = '';

  if (acquirer === 3) {
    acquirerStr = 'Adiq';
  } else if (acquirer === 10) {
    acquirerStr = 'Rede';
  } else if (acquirer === 99) {
    acquirerStr = 'Valori';
  }
  return acquirerStr;
};

export const formatChannel = (channel: string): string => {
  if (channel === 'PHYSICAL') return 'Físico';
  else if (channel === 'DIGITAL') return 'Digital';
  else return '';
}

export const formatBrand = (value: number): string => {
  let brand: string = '';

  switch (value) {
    case 1 : brand = 'Visa';
      break;
    case 2 : brand = 'Master';
      break;
    case 3 : brand = 'Amex';
      break;
    case 9 : brand = 'Hiper';
      break;
    case 171 : brand = 'Elo';
      break;
    default: brand = value.toString()
  }

  return brand
}

export const formatTotal = (value: number): string => {
  if (isNaN(value)) value = 0;
  return formatMoney(value);
}

export const formatDateFilter = (dateString: Date | string): string => {
  const date: Date = new Date(dateString);

  // Pad single digits with leading zero
  const pad = (num: number): string => (num < 10 ? `0${num}` : `${num}`);

  const formattedDate: string = `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;

  return formattedDate;
};

export const formatTakeRate = (value: number): string => {
  if (isNaN(value)) return '0.00%';
  let result = '';
  result = `${(value*100).toFixed(2).toString()}%`;
  return result;
}

export const userCommercial = (commercialHierId: number): string => {
  const valoriId = [
    199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 213, 214, 228, 229, 235, 236, 237, 238
  ];

  const comerciaisParceirosId = [
    196, 216, 232, 233, 234
  ];

  const parceirosId = [
    211, 212, 215, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 230, 231
  ]

  if (valoriId.includes(commercialHierId)) {
    return "valori";
  } else if (comerciaisParceirosId.includes(commercialHierId)) {
    return "comerciaisParceiros";
  } else if (parceirosId.includes(commercialHierId)) {
    return "parceiros";
  } else {
    return "unknown";
  }
}

export const formatBillingType = (product: number): string => {
  if (product === 1) return 'Pos Garantida';
  else if(product === 2) return 'Aluguel de POS';
  else if(product === 3) return 'PDV';
  else if(product === 4) return 'Chargeback';
  else if(product === 5) return 'Cobrança Pontual';
  return '';
}

export const formatDocument = (document: string | number): string => {
// Remove todos os caracteres não numéricos
  const onlyNumbers = document.toString().replace(/\D/g, '');

  // Se não tiver números válidos, retorna vazio
  if (!onlyNumbers) {
    return '';
  }

  // CPF: 11 dígitos - formato: 000.000.000-00
  if (onlyNumbers.length === 11) {
    return onlyNumbers.replace(
      /^(\d{3})(\d{3})(\d{3})(\d{2})$/,
      '$1.$2.$3-$4'
    );
  }

  // CNPJ: 14 dígitos - formato: 00.000.000/0000-00
  if (onlyNumbers.length === 14) {
    return onlyNumbers.replace(
      /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
      '$1.$2.$3/$4-$5'
    );
  }

  // Se não for CPF nem CNPJ válido, retorna apenas os números
  return onlyNumbers;
}

export const formatBusinessName = (companyName: string): string => {
  // Remove o código (6 dígitos) + hífen + espaços e retorna só o nome
  return companyName.replace(/^\d{6}\s*-\s*/, '').trim();
}

// Converte "YYYY-MM-DDTHH:mm:ss" (valor de datetime-local) para Date sem ambiguidade de timezone
export const parseDatetimeLocal = (value: string): Date => {
  const [datePart, timePart] = value.split('T');
  const [year, month, day] = datePart.split('-').map(Number);
  const [hours, minutes, seconds] = (timePart || '00:00:00').split(':').map(Number);
  return new Date(year, month - 1, day, hours, minutes, seconds || 0);
};


export const formatDateToKaptorIso = (date: Date): string => {
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
};

export const formatDateToKaptorPix = (date: Date): string => {
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${date.getFullYear()}${pad(date.getMonth() + 1)}${pad(date.getDate())}${pad(date.getHours())}${pad(date.getMinutes())}${pad(date.getSeconds())}`;
};
